import React from "react";
import { translate } from "../../utils/translations/translate";
import { StyledTimesheetContainer } from "./styles";
import Button from "../UI/Button";
import { Popupmenu } from "../UI/PopupMenu";
import { DOWNLOAD_OPTIONS } from "../../utils/constants";
import { Loader } from "../Loader/Loader";
import { Alert } from "../UI/Alert";
import { TimesheetViewMode } from "./TimesheetViewMode";
import { useTimesheetApproval } from "./hooks/useTimesheetApproval";
import { TimesheetApprovalModal } from "./TimesheetApprovalModal";
import { exportTimesheetToPDF, generateTimesheetExcel } from "../../utils/reports";
import VerifiedIcon from '@mui/icons-material/Verified';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
export const TimesheetApprovalDetails = ({ timesheetId }) => {
  const {
    isPageBusy,
    selectedWeek,
    timesheetInfo,
    toastInfo,
    approvalModalInfo,
    approveOrRejectTimesheet,
    onApproveOrReject,
    onCloseModal,
    showApprovalModal,
    handleToastClose
  } = useTimesheetApproval(timesheetId);
  return (
    <StyledTimesheetContainer>
      {toastInfo && <Alert {...toastInfo} onToastClose={handleToastClose} />}
      <header className="tma_timesheet_header tma__timsheet_approval_header">
        <div className="tma_primary_row">
          <h1 className="page-title">
            {translate("pageTitles.timeSheetApproval")}
          </h1>
          {timesheetInfo && (
            <div className="tma_submit_actions">
              {timesheetInfo.showApproverActionButton && (
                <>
                  <Button
                    type="button"
                    className={"tma_time_submit_btn tma_time_arrove_btn"}
                    variantStyle="primary"
                    text={translate("labels.approve")}
                    onClick={() => {
                      onApproveOrReject("Approved");
                    }}
                    iconcomponent={VerifiedIcon}
                  />
                  <Button
                    type="button"
                    className={
                      "primary-danger-outline tma_time_reject_btn"
                    }
                    text={translate("labels.reject")}
                    onClick={() => {
                      onApproveOrReject("Rejected");
                    }}
                    iconcomponent={UnpublishedIcon}
                  />
                </>
              )}

              <Popupmenu
                type="button"
                popupOptions={DOWNLOAD_OPTIONS}
                variantStyle="secondary"
                label={translate("labels.moreOptions")}
                onOptionSelect={({key})=>{
                  if(key === "excel"){
                    generateTimesheetExcel([timesheetInfo]);
                  }
                  else{
                    exportTimesheetToPDF([timesheetInfo]);
                  }
                }}
              />
            </div>
          )}
        </div>
      </header>
      {timesheetInfo && (
        <TimesheetViewMode
          onModeChange={() => {}}
          isEditable={false}
          comments={timesheetInfo.comments}
          key={timesheetInfo.projectId}
          projectSavedData={timesheetInfo}
          projectName={timesheetInfo.projectName}
          taskRows={timesheetInfo.timesheetData}
          projectId={timesheetInfo.projectId}
          managerName={timesheetInfo.managerName}
          managerEmail={timesheetInfo.managerEmail}
          selectedWeek={selectedWeek}
          approverComments={timesheetInfo.approverComments}
          status={timesheetInfo.status}
        />
      )}
      {isPageBusy && !timesheetInfo && (
        <p>{translate("labels.fetchingTimesheetInfo")}</p>
      )}
      {isPageBusy && <Loader />}
      {showApprovalModal && (
        <TimesheetApprovalModal
          {...approvalModalInfo}
          onClose={onCloseModal}
          onConfirm={approveOrRejectTimesheet}
        />
      )}
    </StyledTimesheetContainer>
  );
};
